import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  align-items: center;
`;
const Label = styled.div`
  background: rgba(133, 113, 77, 0.1);
  border-radius: 0px 0.2em;
  padding: 0 0.5em;
  color: #85714d;
  align-self: center;
`;
const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
const Icon = styled.div``;

const openLink = (props) => {
  window.open(props.url, props.target);
};

const Link = (props) => {
  return (
    <Container
      className={`d-flex py-2 text-start ${
        !!props.href ? "cursor-pointer" : ""
      }`}
      onClick={() => {
        if (!!props.href) {
          openLink({ url: props.href, target: "_self" });
        }
      }}
    >
      <div className="d-flex p-2 w-100">
        {props.label ? (
          <Label className="text-nowrap">{props.label}</Label>
        ) : (
          ""
        )}
        <Title className={props.label ? "px-2" : ""}>{props.title}</Title>
      </div>
      <Icon
        className="p-2 flex-shrink-1 cursor-pointer"
        onClick={() => {
          if (!!props.file) {
            openLink({ url: props.file, target: "_blank" });
          }
        }}
      >
        <props.icon fill="#000"></props.icon>
      </Icon>
    </Container>
  );
};

export default Link;
